<script lang="ts" setup>
import { type FontAwesomeIconProps } from '@fortawesome/vue-fontawesome';
import { FontAwesomeIcon } from '@shared/plugin/icons';
import { useSlots } from 'vue';

import VHeading from '@shared/typography/VHeading/VHeading.vue';

type Size = 'md' | 'xl';

const props = withDefaults(
  defineProps<{
    description?: string;
    icon: FontAwesomeIconProps['icon'];
    size?: Size;
    title: string;
  }>(),
  {
    size: 'md',
  },
);

const iconContainerClasses: Record<Size, string> = {
  md: 'tw-size-[5.5rem] tw-mb-6',
  xl: 'tw-size-44 tw-mb-8',
};

const slotContainerClasses: Record<Size, string> = {
  md: 'tw-mt-6',
  xl: 'tw-mt-8',
};

const slots = useSlots();
</script>

<template>
  <div class="tw-mx-auto tw-flex tw-max-w-xl tw-flex-col tw-items-center tw-justify-center">
    <div
      :class="[
        'tw-flex tw-items-center tw-justify-center tw-rounded-full tw-bg-grey-accent-100',
        iconContainerClasses[props.size],
      ]"
    >
      <FontAwesomeIcon class="tw-h-1/4 tw-text-grey-accent-200" :icon="props.icon" />
    </div>

    <VHeading class="tw-text-center" :level="2" appearance="xs">
      {{ props.title }}
    </VHeading>

    <p
      v-if="props.description"
      class="tw-mt-4 tw-max-w-xl tw-text-center tw-leading-normal tw-text-primary-900"
    >
      {{ props.description }}
    </p>

    <div v-if="slots.default" :class="slotContainerClasses[props.size]">
      <slot></slot>
    </div>
  </div>
</template>
